import { Autocomplete, FormControl, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DropDownProdutoServico } from "../../../../../../common/components/dropdown_produtoservico";
import { DefaultProduto } from "../../../../../../common/components/default_produtor_select";

// Header 

type Props = {
  ProdutorPesquisa: number;
  onClearFilters: () => void;
  handleProdutorChange: (v: number) => void;
};


export const Header = ({ ProdutorPesquisa, onClearFilters, handleProdutorChange}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-4 grid-cols-1 md:grid-cols-2">
          <FormControl size="small" fullWidth>
            <DefaultProduto
              key={`prod-${ProdutorPesquisa}`} 
              name="PesquisarProdutor"
              value={ProdutorPesquisa || null}
              onChange={(valor) => handleProdutorChange(Number(valor))}
              label="Produto"
            />
          </FormControl>
          <div className="w-full flex justify-end md:col-span-2 mt-2">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}